import { useForm as useMantineForm } from '@mantine/form';

export const useForm = useMantineForm;
